import * as services from './managelocation.services'
export default {
  data() {
    let context = this
    var validLocationName = (rule, value, callback) => {
      if (context.NewLocation.LocationName == "") {
        return callback("Please Enter Facility Name")
      } else {
        return callback();
      }
    }
    return {
      locations_columns: ['LocationName', 'LocationAddress', 'LocationPhoneNumber', 'LocationFaxNumber',
        'UsersCount',
        'PoolsCount',
        'Actions'
      ],
      optionstable: {
        headings: {
          LocationName: 'Facility Name',
          LocationAddress: 'Facility Address',
          LocationPhoneNumber: 'Facility Phone Number',
          LocationFaxNumber: 'Facility Fax Number',
          UsersCount: 'Users',
          PoolsCount: 'Venues',
          Actions: ''
        },
        //  templates: {
        //  UsersCount: function (h, row) {
        //      return `<a href='javascript:void(0);' @click='$parent.deleteMe(${row})'><i class='glyphicon glyphicon-erase'></i></a>`
        //   },
        // },

        perPage: 5,
        perPageValues: [5, 10, 25, 50, 100],
        /*  sortable: ["ActionDate","Description", "CommentedBy", "ActionTypeName"],*/
        sortable: [],
      },
      user_columns: ['SlNo', 'UserName'],
      optionsusertable: {
        headings: {
          SlNo: '#',
          UserName: 'User',
        },
        perPage: 5,
        perPageValues: [5, 10, 25, 50, 100],
        sortable: [''],
      },
      pool_columns: ['SlNo', 'PoolName'],
      optionspoolstable: {
        headings: {
          SlNo: '#',
          PoolName: 'Venue',
        },
        perPage: 5,
        perPageValues: [5, 10, 25, 50, 100],
        sortable: [''],
      },
      Locations: {
        IsIdealRange: "",
        LocationAddress: "",
        LocationCreatedOn: "",
        LocationFaxNumber: "",
        LocationId: "",
        LocationIsActive: "",
        LocationName: "",
        LocationOffset: "",
        LocationOrganizationId: "",
        LocationOrganizationName: "",
        LocationPhoneNumber: "",
        LocationUpdatedOn: "",
        Pools: [],
        SearchTag: "",
        //FG - FOOF - After Cert - First Release - (1) FORCE DEFAULT TO BE MAHC, thus null for StateId (was setting to "")
        StateId: null, //"",
        StateName: "",
        Users: [],
        UsersCount: '',
        PoolsCount: '',
      },
      options: [],
      isediting: false,
      isuserlist: false,
      isAddingOrEditing: "",
      NewLocation: {
        LocationName: "",
        LocationAddress: "",
        LocationFaxNumber: "",
        LocationPhoneNumber: "",
        IsIdealRange: '',
        //FG - FOOF - After Cert - First Release - (1) MAKE MAHC THE DEFAULT CHOICE
        StateId: null //''

      },
      UsersList: [],
      PoolsList: [],
      isShowallLocations: false,
      rules: {
        LocationName: [{
          validator: validLocationName,
          trigger: 'blur'
        }]
      }
    }
  },
  mounted() {
    this.GetAllLocationList(true)
    this.getstates()
  },
  methods: {
    GetAllLocationList(status) {
      let context = this
      services.GetAllLocationList(status).then(function (response) {

      //Is this restricted ? -- FG - After Cert - First Release Security
      if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) { 
        context.Locations = []    
        loader.stopLoader()
        return;
      }


        context.Locations = response
        context.Locations.filter(function (item) {
          item.UsersCount = item.Users.length
          item.PoolsCount = item.Pools.length
        })
      }, (error) => {

      })
    },
    addLocation(formName) {
      this.isAddingOrEditing="A"
      this.showPopup(formName)
      this.resetEditAdd()
      this.isediting = false
    },
    CancelledAddFacility() {
      isAddingOrEditing=""
    },
    editlocation(item) {
      this.NewLocation.LocationId = item.row.LocationId
      this.isediting = true
      this.isAddingOrEditing="E"
      this.showPopup()
      this.NewLocation.LocationName = item.row.LocationName
      this.NewLocation.LocationAddress = item.row.LocationAddress
      this.NewLocation.LocationFaxNumber = item.row.LocationFaxNumber
      this.NewLocation.LocationPhoneNumber = item.row.LocationPhoneNumber
      //FG - FOOF - After Cert - First Release - (1) the radio button changed for all faciclities when changed in one
      //     AND we there was sometimes nothing chosen.
      //     IN AN EFFORT TO NOT CHANGE GOO MUCH I AM STAYING WITH THE VALUES 1 and 2 for the radio button  (THAT CAME FROM DIGICLARITY)
      if(item.row.IsIdealRange)
        this.NewLocation.IsIdealRange = "true";
      else
        this.NewLocation.IsIdealRange = "false";
 

    },
    //FG - FOOF - After Cert - First Release (6) - rewrote delete code below to use new methods in hydrowareCommonJS.js
    //The delete function below deletes a row from the table
    DeleteLocation(props){
      let context = this
      var locid = props.row.LocationId
      var opts = {message: 'Are you sure you want to delete ' + props.row.LocationName + '?'}
      context.$hydrowareCommonJS.displayConfirmDeletePopup(context, opts, context.deleteLocationRow.bind(null,locid))
    },
    deleteLocationRow(locid) {
      var context = this;
      loader.startLoader()
      services.DeleteLocation(locid).then(function (response) {

        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) { 
          loader.stopLoader()
          return;
        }

        context.GetAllLocationList(true);
        context.$hydrowareCommonJS.notifyDeleteSuccess(context);
        loader.stopLoader()
      },
      (error) => {
        loader.stopLoader()
        context.$hydrowareCommonJS.notifyError(context,{message: error.responseJSON.Message})
      })
    },
    
    getstates() {

      let context = this

      services.GetStates().then(function (response) {

        //FG - FOOF - After Cert - First Release - (1) ONLY FOR MAHC SO WE DON'T POPULATE DROP DOWN LIST WITH STATES
        //     IF/WHEN we supply state bating codes the line below should be uncommented
        //context.options = response

        context.options.unshift({
          "StateId": null,
          "StateName": "MAHC"

        })
        context.SelectedState = context.options[0].StateId
        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })
    },
    toggleLocationList() {

      this.isShowallLocations = !this.isShowallLocations
      this.GetAllLocationList(this.isShowallLocations ? null : "true")
    },
    UpdateLocation(formName) {
      let context = this
      loader.startLoader()
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (context.NewLocation.IsIdealRange == 1)
            context.NewLocation.IsIdealRange = true
          else if (context.NewLocation.IsIdealRange == 2)
            context.NewLocation.IsIdealRange = false
          services.UpdateLocation(this.NewLocation).then(function (response) {

            //Is this restricted ? -- FG - After Cert - First Release Security
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {  
              loader.stopLoader()
              return;
          }

            context.GetAllLocationList(this.isShowallLocations ? null : "true");
            context.$notify({
              title: 'Success',
              message: 'Facility Updated',
              type: 'success'
            })
            loader.stopLoader()
            $('#Addlocationmodel').modal('hide')
          }, (error) => {
            context.$notify({
              title: 'Error',
              message: error.responseJSON.Message,
              type: 'error'
            })
          })
        } else {
          context.$notify({
            title: 'Error',
            message: 'Enter location Name',
            type: 'error'
          })
          loader.stopLoader()
        }
      })
    },
    Createlocation(formName) {
      let context = this
      loader.startLoader()
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (context.NewLocation.IsIdealRange == 1)
            context.NewLocation.IsIdealRange = true
          else if (context.NewLocation.IsIdealRange == 2)
            context.NewLocation.IsIdealRange = false
          services.Createlocation(this.NewLocation).then(function (response) {

            //Is this restricted ? -- FG - After Cert - First Release Security
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {   
                loader.stopLoader()
                return;
            }

            context.GetAllLocationList(this.isShowallLocations ? null : "true");
            context.$notify({
              title: 'Success',
              message: 'Created Facility',
              type: 'success'
            })
            loader.stopLoader()
            $('#Addlocationmodel').modal('hide')
          }, (error) => {
            context.$notify({
              title: 'Error',
              message: error.responseJSON.Message,
              type: 'error'
            })
          })
        } else {
          context.$notify({
            title: 'Error',
            message: 'Enter Facility Name',
            type: 'error'
          })
          loader.stopLoader()
        }
      })
    },
    ChangeStatus(item) {
      let context = this
      loader.startLoader()
      services.ChangeLocationStatus(item.row.LocationId, !item.row.LocationIsActive).then(function (response) {

        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {   
          loader.stopLoader()
          return;
        }
      
        
        context.GetAllLocationList(true);
        context.$notify({
          title: 'Success',
          message: 'Status Changed',
          type: 'success'
        })
        loader.stopLoader()

      }, (error) => {
        context.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
        loader.stopLoader()
      })
    },
    showPopup(formName) {

      let context = this
      context.buttonclicked = true
      this.isadding = true
      $('#Addlocationmodel').modal('show')
    },
    showUser(item) {
      this.isuserlist = true
      $('#LocationDetailmodel').modal('show')
      this.UsersList = item.Users
    },
    showPools(item) {
      this.isuserlist = false
      $('#LocationDetailmodel').modal('show')
      this.PoolsList = item.Pools
    },
    resetEditAdd() {
      this.NewLocation.LocationName = "",
        this.NewLocation.LocationAddress = "",
        this.NewLocation.LocationFaxNumber = "",
        this.NewLocation.LocationPhoneNumber = ""
         //FG - FOOF - After Cert - First Release - (1) the radio button changed for all faciclities when changed in one
         //     AND we there was sometimes nothing chosen.
         //     IN AN EFFORT TO NOT CHANGE GOO MUCH I AM STAYING WITH THE VALUES 1 and 2 for the radio button  (THAT CAME FROM DIGICLARITY)
      this.NewLocation.IsIdealRange = "false";
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/Administration/ManageLocation/managelocation.controller.js